const es = {
  question:{
    indication : "Por favor danos tus comentarios sobre el siguiente texto bíblico: "
  },
  link: {
    title: 'Artículo muy interesante en el sitio web oficial de los Testigos de Jehová:',
    subject: 'Casarse “solo en el Señor”, ¿sigue siendo realista?'
  },
  messages: {
    usernameAlert: {
      text: "Su nombre de usuario debe ser diferente de su nombre real. No debe reflejar su nombre o apellido reales, ni el nombre de usuario que ud utiliza en sus redes sociales. Incluya solamente letras y números, sin espacios ni caracteres especiales."
    },
    loading_subscription_state: "Cargando estado de suscripción...",
    error_subscription_detail: "Error al obtener su estado de suscripción, recarga el navegador o intenta mas tarde.",
    renewal: {
      title: "Renovación automatica",
      intro: "Si deseas cancelar tu renovación automatica, haz clic en el siguiente boton:",
      empty: "Tu renovación automatica ya esta cancelada",
      alert: {
        title: "Renovación automatica cancelada",
        text: "Tu renovación automatica fue cancelada."
      }
    },
    choose_step: "Seleccione un paso",
    ads: {
      thankyou: "Gracias por elegir JWperfectmatch",
      since: "Construyendo relaciones JW desde Marzo de 2020",
      share: "Compartir JWperfectmatch"
    },
    userTypes: {
      title: "¿Que tipo de Usuarios existen en JWperfectmatch?",
      premium: {
        title: "Usuario Premium",
        type: "Punto amarillo",
        content_1: "Al suscribirte puedes optar por convertirte en un usuario premium, dando click en la casilla designada. Siendo un usuario premium te permitirá poder recibir respuestas escritas, asi como llamadas y videollamadas de todos los usuarios suscritos. Además, podrás recibir respuestas escritas de todos los usuarios no suscritos. El costo adicional de esta opción es de $14/mes con renovación automática.",
        content_2: "Si estás muy interesado(a) en un usuario no suscrito y deseas recibir respuesta por escrito, realizar llamadas o videollamadas, tienes la opción de enviarle un regalo. Al hacerlo, podrás realizar llamadas o videollamadas con ese usuario, por un lapso de siete días desde la compra del regalo.",
        content_3: "Eventualmente podemos enviarte una oferta para que te suscribas como ususario premium bajo la modalidad de pago de US $15 por 15 dias con renovacion automática. Esta conveniente oferta te permitira gozar de todas las ventajas de ser un usuario premium por un costo menor. Puedes cancelar la renovación automatica de esta suscripcion cuando tu quieras, siguiendo el procedimiento establecido dentro de los Términos de uso bajo el apartado: <b>¿Puedo cancelar la renovación automática?</b>, dentro de dicha sección encontrarás el procedimiento a seguir para cancelar la renovación automática de tu suscripción. Debes tener en cuenta que si compras la suscripcion  US $15 por quince dias no podras solicitar un reembolso. Tu debes estar de acuerdo con esta condicion, de lo contrario no deberas comprar esta suscripcion."
      },
      subscribed: {
        title: "Usuario suscrito",
        type: "Punto azul",
        content: "Al suscribirte en cualquiera de nuestros planes mensual, trimestral, semestral o anual, te convierte en un usuario suscrito. Siendo un usuario suscrito, te permitirá recibir respuestas escritas, llamadas o videollamadas de otros usuarios suscritos. Si deseas contactar a otros usuarios aun no suscritos, podrás hacerlo mediante mensajes predeterminados o bien a través de Emojis. Si estás muy interesado(a) en un usuario no suscrito y deseas recibir respuesta por escrito, realizar llamadas o videollamadas, tienes la opción de enviarle un regalo. Al hacerlo, podrás recibir mensajes escritos, realizar llamadas o videollamadas con ese usuario, por un lapso de siete días desde la compra del regalo."
      },
      none: {
        title: "Usuario no suscrito",
        type: "Punto azul",
        content: "Al registrarte y crear tu perfil en JWperfectmatch, tendrás acceso a la búsqueda de otros usuarios ya sean suscritos o no suscritos dentro del sitio web. Podrás realizar contacto con otros usuarios a través de la plataforma de chat, y enviar mensajes predeterminados y Emojis, para expresarte. Para poder realizar llamadas o videollamadas con otros usuarios suscritos, deberás suscribirte a cualquiera de nuestros accesibles planes de suscripción con renovación automática. Esto te dará muchas ventajas para conocer a otros usuarios en los que estés interesado(a)."
      },
      gift: {
        title: "Envío de regalo",
        content_1: "Esta opción está disponible y accesible para los usuarios suscritos. Podrás enviar un regalo a aquel usuario(a) no suscrito en quien estés interesado(a). Si eres un usuario Premiun y deseas realizar llamadas o videollamadas con un usuario no suscrito, podrás hacerlo al enviar un regalo. De esta forma podrás contactar al usuario no suscrito a través de llamadas y videollamadas durante un lapso de siete días a partir de la fecha de compra del regalo. Al recibir un regalo de tu parte, el usuario no suscrito y tú, podrán mantener contacto escrito, llamadas o vídeollamadas. Un usuario no suscrito únicamente podrá contactar por medio de chat, llamadas o videollamadas a quien le ha enviado un regalo.",
        content_2: "Si eres un usuario suscrito y deseas recibir y enviar mensajes escritos, realizar llamadas o videollamadas con un usuario no suscrito, podrás hacerlo al enviar un regalo. De esta forma podrás contactar al usuario no suscrito a través de llamadas y videollamadas durante un lapso de siete días a partir de la fecha de compra del regalo. Al recibir un regalo de tu parte, el usuario no suscrito y tú, podrán mantener contacto escrito, llamadas o videollamadas. Un usuario no suscrito únicamente podrá contactar por medio de chat, llamadas o videollamadas a quien le ha enviado un regalo."
      },
      gift_subscription: {
        title: "FELICIDADES",
        message: "Has sido seleccionado para recibir un obsequio de tus hermanos y hermanas aquí en JWperfectmatch, de 15 días de suscripción premium. <br> Gracias por ser un cliente leal en JWperfectmatch. Esperamos que disfrutes de nuestro regalo.&#127873;",
        button_accept: "Abrir mi regalo &#127873;",
        button_cancel: "Cancelar",
        confirm: "Regalo canjeado"
      },
      upgrade: {
        title: "¿Deseas actualizar tu suscripcion standard a Premium?",
        content_1: "Si desea pasar de la suscripción estándar a la Premium, puede hacerlo cuando lo desee pagando las siguientes tarifas fijas: Suscripción de 1 mes: US $ 14,00; Suscripción de 3 meses: US $ 39,99; suscripción de seis meses: US $ 79,99 y suscripción de doce meses o un año; US $ 155,00.",
        content_2: "Estas tarifas fijas serán cargadas adicionalmente al pago de su suscripción y se aplicaran en cualquier momento en que usted decida cambiar de suscripción standard a Premium.",
        content_3: "No se le permite solicitar un reembolso por el pago de estas tarifas. Usted acepta que no podrá solicitar la devolución del pago de las tarifas fijas anteriores."
      }
    },
    emailconfirm: {
      title: "Por favor confirme su dirección de correo electrónico",
      description: "En JWperfectmatch queremos brindarle la mayor seguridad en la creación de su perfil de usuario. Por esta razón le hemos enviado un correo electrónico a su dirección de  {email}. Ingrese el código de confirmación de 4 caracteres proporcionado en el correo electrónico en el campo a continuación:",
      legend: "Por favor recuerde revisar su carpeta de correo no deseado o basura",
      help_message: "¿No recibió el correo electrónico?",
      verify: "Por favor verifique que la dirección de email  sea la  correcta y",
      resend: "vuelva a enviarla.",
      button: "Validar",
      resendMessage: "Te hemos reenviado un nuevo token",
      verifyError: "Error al verificar tu correo, porfavor verifica que ingresaste un código valido.",
      exceeded: "Haz superado el número de intentos permitidos."
    },
    connectycube: {
      error: {
        title: 'Lo sentimos',
        description: 'Estamos experimentando dificultades técnicas. Por favor inténtelo mas tarde.',
        action: 'Ir a perfil'
      },
    },
    languages: {
      english: "Ingles",
      spanish: "Español"
    },
    user_profile: {
      about_me: {
        age: {
          label: 'Edad',
          years: '{years} años'
        }
      },
      about_my_couple: {
        age_range: {
          label: 'Rango de edad',
          range: '{from} - {to} años'
        }
      }
    },
    general: {
      subscription15days: {
        title: '¡Oferta por tiempo limitado!',
        content: 'Suscripción Premium de 15 días por solo US$15 con renovación automática. Obtén llamadas y mensajes de texto ilimitados con otros miembros suscritos y chat ilimitado con todos los usuarios.',
        button: 'Hazte premium por solo US$15'
      },
      blocked_profile: 'Este ususario se encuentra en modo invisible. No disponible',
      expired_subscription: "Su pago de suscripción no se realizó correctamente, por favor actualice su información de facturación",
      phone_comfirm: {
        title: "IMPORTANTE",
        message: "Para continuar por favor ocnfirma tu numero de movil",
      },
      title_jw: "¿Listo para empezar? ¡Será emocionante comenzar a conocer a otros usuarios!",
      subscribe_button_jw: "¡Empieza ahora!",
      subscribe_jw: "Listo para comenzar JW Dating?",
      actions: "Acciones",
      chat_not_allowed: "No tienes permiso para chatear con esta persona.",
      tell_your_friends_btn: "Comparte con tus amigos JWperfectmatch!",
      page_title: "Jehovah's witnesses dating site",
      auth_failed: "El password o email son  incorrectos",
      auth_banned: "Usuario no encontrado, por favor contacta a soporte",
      home: "Inicio",
      support: "Soporte",
      security: "Seguridad",
      privacy: "Politicas de privacidad",
      terms: "Términos de uso",
      contact: "Contáctanos",
      tips: "Consejos JW",
      engagement: "Noviazgo JW",
      conduct: "Conducta JW",
      rights: "Todos los derechos reservados",
      login: "Ingresar",
      log_in: "Iniciar Sesión",
      login_account: "Iniciar sesión en tu cuenta",
      forgot_password: "¿Ha olvidado su contraseña?",
      stay_connected: "Permanecer conectado",
      return_home: "Regresar a inicio",
      are_you_member: "¿No eres miembro aún?",
      sign_up_free: "Registrate gratis",
      sign_up_message:
        "¡Regístrate gratis, crea tu perfil y comienza a conocer gente ya!",
      i_am: "Soy un/una",
      man: "Hombre",
      men: "Hombre",
      woman: "Mujer",
      women: "Mujer",
      female_is: "Ella es",
      male_is: "Él es",

      age_range: "Rango de edad",
      subscription_title: "Subscripción",
      every15days: "Cada 15 días",
      sign_up_now: "Registrate ahora",
      already_user: "¿Ya eres un usuario registrado?",
      subscribe_free_now:
        "¡Suscríbete gratis ahora, será emocionante comenzar a conocer otros usuarios!",
      subscribe_free: "¡Suscribete gratis y comienza a conocer personas ya!",
      subscribe_now: "Suscríbete ya",
      continue_reading: "Leer más",
      see_more: "Leer más",
      see_my_profile: "Ver mi perfil",
      mobile_verified: "Móvil verificado",
      see_profile: "Ver perfil",
      mobile_no_verified: "Móvil no verificado",
      years: "años",
      verified_now: "Confirma tu móvil ahora",
      connection: "Conexión",
      last_connection: "Ultima Conexión",
      now: "Ahora",
      my_activity: "Mi actividad",
      search: "Buscar",
      messages: "Mensajes",
      visits_to_your_profile: "Visitas a tu perfil",
      favorites: "Favoritos",
      reciprocal_favorites: "Favoritos recíprocos",
      invitations: "Invitaciones",
      invitations_message: "En esta sección, encontrarás los usuarios que te agregaron como favorito, te saludaron o te enviaron un regalo.",
      tell_your_friends: "Díselo a tus amigos",
      visits_title: "Visitas a tu perfil",
      subscribe: "Suscríbete",
      profile: "Perfil",
      logout: "Cerrar sesión",
      edit_profile: "Editar mi perfil",
      subscription_status: "Estado de suscripción",
      subscription_message:
        "Actualmente eres un suscriptor activo del sitio de citas para Testigos de Jehová solteros JWperfectmatch.",
      subscription_info: "Datos de subscripción",
      payment_method: "Tipo de pago",
      subscription: "Suscripción",
      subscription_date: "Fecha de suscripción",
      period: "Periodo",
      expiration_date: "Fecha de caducidad",
      automatic_renewal: "Renovación automática",
      currency: "Moneda",
      amount: "Importe de suscripción",
      last_payment: "Ultimo pago",
      day: "días",
      locked_profiles: "Perfiles bloqueados",
      subscription_renewal: "Renovación de Suscripción",
      send: "Enviar",
      loading_messages: "Cargando mensajes...",
      send_gift: "Enviar regalo",
      has_sent_you_a_gift: 'te ha enviado un regalo',
      compatibility: "Compatibilidad",
      no_available: "No Disponible",
      greet: "Saludar",
      touch: "Contactar",
      add_to_favorites: "Añadir a favoritos",
      remove_to_favorites: "Remover de favoritos",
      more: "Más",
      block_user: "Bloquear usuario",
      report_bullying: "Denunciar acoso",
      user_types: "Tipos de usuarios",
      to_see_and_meet: "Para ver y conocer más usuarios.",
      visited_profile: "Tu perfil ha sido visitado",
      visits_today: "Este día",
      visits_last_week: "La última semana",
      visits_monthly: "Este mes",
      visits_3_months: "Hace 3 meses",
      search_users: "Buscar usuarios...",
      select_an_option: "Seleccione un opción",
      previous: "Anterior",
      next: "Siguiente",
      last_modification: "Última modificación de perfil",
      profile_creation: "Fecha de creación de perfil",
      match_filter: "Filtrar por match",
      typing: "Escribiendo",
      reply: "Escribe una respuesta",
      favorites_status_message:
        "Hemos encontrado personas que cumplen con sus criterios de búsqueda.",
      subscribe_today: "¡Suscríbete ahora!",
      subscribe_message:
        "Obtén acceso a todas las funciones y ventajas que te ofrecemos !Podras intercambiar mensajes de texto, voz y disfrutar de videochat. Te encantará!",
      favotites_added_message: "Te han agregado a sus favoritos",
      subscribe_message_mini: "¡Será emocionante comenzar a conocer a otros usuarios!",
      days_ago: "Hace {days} días",
      smiles_sended_message: "Te han enviado una sonrisa",
      subscription_gifts_message: "Regalos de suscripción",
      blocked_users_message:
        "Estos son los usuarios que has bloqueado. Recuerda que puedes desbloquear a quien tú quieras cuando así lo decidas. ¡Tu siempre tienes el control!",
      unlock: "Desbloquear",
      you_are: "Tú eres",
      related_to: "compatible con",
      related_to_me: "compatible contigo",
      contacts_to_see_message:
        "Tenemos más de 20 contactos que pensamos deberias ver.",
      more: "Más",
      added_to_favorites: "Haz agregado a este usuario a tu lista de favoritos.",
      add_favorites: "te ha añadido a sus favoritos",
      removed_from_favorites: "Este usuario ya no es tu favorito.",
      has_greeted_you: "te ha saludado",
      see_now: "Ver ahora",
      see_later: "Ver despues",
      accept: "Aceptar",
      smile: "Sonrisa",
      smile_sent: "Le has enviado una sonrisa a este usuario",
      continue: "Continuar",
      featured_profiles: "¡Empieza a hacer nuevas amistades!",
      nothing_to_show: "Nada que mostrar",
      see_more: "Ver más",
      see_less: "Ver menos",
      of: "de",
      success_email: "Enviado con éxito, revisa tu correo.",
      error_email: "No podemos encontrar ningún usuario con ese correo electrónico.",
      accept_call: "Aceptar llamada",
      reject_call: "Detener llamada",
      profile_tables: {
        description: "Descripción",
        about_table: {
          me: "Acerca de {name}",
          ideal_couple: 'Pareja ideal de {name}'
        },
        personality_table: {
          me: "Personalidad de {name}",
          ideal_couple: 'Personalidad de pareja ideal de {name}'
        },
        more_about_table: {
          me: "Más acerca de{name}"
        },
        about_me_table: {
          me: "Acerca de mi",
          ideal_couple: "Acerca de mi pareja ideal"
        },
        my_personality_table: {
          me: "Mi personalidad",
          ideal_couple: "Personalidad de mi pareja ideal"
        }
      },
      alert_message: {
        voice: "{username} te esta llamando.",
        video: "{username} te esta video llamando."
      },
      busy_call: {
        message: 'El usuario que intenta llamar está ocupado, por favor intente mas tarde.',
        accept: 'Cerrar'
      },
      calling: "Llamando...",
      cancel_call: "Cancelar llamada",
      months: "meses",
      month: "mes",
      monthly: "mensual",
      biweekly: "quincenal",
      days: "días",
      save: "Ahorra",
      "get_start": "Comenzar",
      cancel: "Cancelar",
      visits:
        "Podrás ver quién ha visitado tu perfil y descubrir a quien le interesas.",
      year: "Año",
      are_you_sure: "¿Estas seguro?",
      cancel_alert:
        "¿Deseas cancelar tu suscripción y ya no disponer de todos los beneficios de JWPerfectMatch?",
      yes_cancel: "Si, cancelarla",
      no_keep: "No, mantenerla",
      register: "Registro",
      create_profile: "Crea tu perfil",
      save_and_finish: "Guardar y Finalizar",
      save_and_continue: "Guardar y Continuar",
      stories_happy: "Historias de Amor",
      yes: "Sí",
      no: "Inactiva",
      start_search: "Iniciar búsqueda",
      labelusername:"Nombre de Usuario",
      message_search:
        "¡Obtén acceso a todas las funciones y ventajas que te ofrecemos! Podrás intercambiar mensajes de texto, voz y disfrutar de videochat. !Te encantara!",
      order_by: "Ordenarlos por",
      message_tell_friends:
        "¡Hola, quiero compartir con ustedes el sitio de citas en línea para los Testigos de Jehová genuinos JWperfectmatch! Fue diseñado para cuidar la limpieza dentro de la congregación de hermanos y hermanas solteros en todo el mundo. Dado que existen filtros específicos para aceptar únicamente a los testigos de Jehová activos, muchos hermanos y hermanas lo están utilizando. Es fácil de usar; puedes unirte gratis; y lo mejor de todo, este sitio seguro y confiable mantendrá sus datos e información privados y seguros.",
      sent_success: "¡Mensaje enviado con éxito!",
      message_delete_profile:
        "Si deseas darte de baja de JWPerfectMatch y borrar completamente y permanentemente tu perfil puedes",
      delete_profile: "eliminar perfil",
      description: "Tu Descripción",
      education: "Educación",
      heart_logo_message:
        `Trata de ver más allá, esfuérzate por descubrir la “Persona secreta del corazón”<br/> <tooltip :customClasses="['text-jpink-primary']" message="Sino, que sea la persona secreta del corazón, en la [vestidura] incorruptible del espíritu quieto y apacible, que es de gran valor, a los ojos de Dios.">(1 Pedro 3:4)</tooltip>`,
      download_app_title: "Descargar Ahora!",
      coming_app_title: "Muy Pronto",
      no_messages: "No hay mensajes...",
      connection: "Conexión",
      complete_fields:
        "Por Favor revisar que todas las preguntas están completas.",
      band:
        "Suscríbete y disfruta con videollamadas, llamadas, mensajes de texto y Emojis exclusívamente para Testigos de Jehová.",
      back: "Volver",
      stories: 'Historias de amor',
      revision_pending: 'Pendiente de revisión'
    },
    complaints: {
      title: "Denunciar acoso",
      subtitle: "Tu seguridad es nuestra prioridad",
      description:
        "Hemos recibido su mensaje y lo revisaremos. Le haremos saber si necesita más información.",
      message:
        "Ya sea que se trate de una conducta inapropiada o bien un incidente serio, te pedimos que lo reportes de forma inmediata y confidencial llenando el siguiente formulario.",
      other_reason:
        "Si deseas contactar a nuestro equipo de soporte por otra razón, haz click aquí",
      click_here: "Click aquí",
      form: {
        type_complaint: {
          label: "Tipo de denuncia",
          types: {
            inappropiate_behavior: "Quiero reportar a un usuario por comportamiento inapropiado",
            serious_incident: "Quiero denunciar un incidente grave."
          }
        },
        type_complaint_placeholder:
          "Deseo informar el mal comportamiento de un usuario",
        your_name: "Tu nombre",
        email: "Correo electrónico",
        username_report: "Nombre de usuario que reportas",
        complaint_subject: "Asunto",
        your_complaint: "Tu denuncia",
        your_complaint_placeholder: "Escribe tu denuncia"
      }
    },
    logout: {
      title: "Cerrar sesión",
      cancel: "Cancelar",
      accept: "Aceptar",
      satisfactions_title:
        "¿Qué tan satisfecho estás con tu sesión en JWPerfectMatch hoy?",
      satisfaction_one: "Muy satisfecho",
      satisfaction_two: "Algo satisfecho",
      satisfaction_three: "Ni satisfecho ni insatisfecho",
      satisfaction_four: "Algo insatisfecho",
      satisfaction_five: "Muy insatisfecho"
    },
    stories: {
      title: "Historias de Amor",
      description: "Escribe tu historia de amor aqui.",
      extra_description: "<b>JW Perfect Match</b> tiene estrictas medidas de seguridad para garantizar que nuestros <b>JW Singles</b> disfruten de una experiencia segura de <b>JW Dating</b> en nuestro sitio.",
      register: "<u>Regístrate ahora</u> y se parte del <b>mejor y genuino sitio de citas de testigos de Jehová.</b>",
      result: "Resultado de historias",
      return: "regresar a historias",
      form: {
        title: "Título de la historia",
        description: "Descripción de su historia",
        body: "Mi historia",
        publish: "Enviar tu historia"
      },
      empty: "Por el momento no se han escrito historias.",
      title_modal: "Su historia ha sido creada",
      description_modal: "Su Historia ha sido creada y será evaluada por JWPerfectMatch"
    },
    favorites: {
      result: "Resultado de favoritos"
    },
    form: {
      username: "Nombre de usuario",
      email: "Correo Electrónico",
      password: "Contraseña",
      repeat_password: "Confirmar Contraseña",
      name: "Nombre",
      full_name: "Nombre completo",
      card_number: "Número de tarjeta"
    },
    welcome: {
      title_line_one: "¡Bienvenido(a) a JWperfectmatch!",
      title_line_two: "El sitio de citas para Testigos de Jehová solteros(as).",
      main_message:
        "Nuestro objetivo en <strong>JWperfectmatch</strong> es reunir miembros activos y bautizados de la congregación mundial de Testigos de Jehová que estén interesados(as) en construir una relación amorosa auténtica basada en principios, respeto y obediencia a las normas y disciplina provenientes  de Jehová Dios.",
      second_message:
        "Al dar click en el siguiente botón de “Continuar”, usted confirma  que ha brindado su información personal  de forma honesta y fidedigna  y que es actualmente un(a) Testigo de Jehová bautizado y activo(a)*. Además usted acepta los Términos de uso, Política de privacidad, consejos de seguridad y respuestas a preguntas frecuentes del presente sitio.",
      disclaimer:
        "*Se considera Testigo de Jehová activo(a), a quien  predica las buenas nuevas del Reino con denuedo, asiste con regularidad a las  reuniones semanales  dentro del Salón del Reino de los Testigos de Jehová de su localidad, además  respeta, promueve y vive de acuerdo a los principios bíblicos, observando las normas de conducta que se siguen dentro de la Congregación de los Testigos de Jehová."
    },
    verify: {
      title: "Verifica tu número de celular",
      description:
        "Aumenta el nivel de confianza en tu perfil de usuario. Te recomendamos encarecidamente que verifiques tu número de teléfono móvil para crear una atmósfera de confianza y seguridad en la interacción dentro del sitio web.",
      mobile_phone: "Teléfono móvil",
      confirm: "Confirmar número móvil",
      later: "Lo haré mas tarde",
      introduce_code: "Introducir código de verificación",
      example: 'Ejemplo: 1234',
      incorrect_code: "Código de verificación incorrecto",
      verified: "Verificado",
      mobile_verified:
        "Su número de teléfono móvil fue verificado correctamente",
        change: "Cambiar numero de teléfono"
    },
    find_match: {
      title: "Maneras de encontrar un match perfecto",
      compatibility_title: "Búsqueda de compatibilidad",
      compatibility_content:
        "Encuentra posibles parejas afines con nuestro motor de búsqueda de compatibilidad.",
      videocalls_title: "Videollamadas",
      videocalls_content:
        "Contacta  con otros usuarios mediante videollamadas, llamadas de voz y mensajes de texto al suscribirte. ¡Ahora no necesitarás compartir tu número de teléfono móvil para hacerlo!",
      private_message_title: "Mensajería Privada",
      private_message_content:
        "Cuando quieras, contacta con otros usuarios utilizando nuestro sistema de mensajería privada.",
      discovery_title: "Descubrir cosas en común.",
      discovery_content:
        "Comprueba al instante las cosas que tienes en común con otros usuarios o posibles parejas afines.",
      you_decide_title: "Tú decides",
      you_decide_content:
        "Puedes bloquear usuarios que no cumplan con tus estándares o denunciar a alguien molesto.",
      add_favorites_title: "Añade Favoritos",
      add_favorites_content:
        "Añade a los usuarios que te gusten a tu red de Favoritos."
    },
    forgot_password: {
      title: "¿Olvidaste tu contraseña?",
      description:
        "Introduce tu correo electrónico y te enviamos un email para que puedas modificar tu contraseña y crear una nueva.",
      email: "Dirección de correo electrónico",
      recovery: "Cambia tu contraseña",
      reset: "La contraseña ha sido actualizada"
    },
    upgrade: {
      title: "Hazte Premium",
      description: "Agrega una suscripción Premium y podrás obtener<br />respuestas de todos los usuarios no suscritos.",
      become_premium: "Hazte Premium"
    },
    subscription: {
      save_label : "¡AHORRA YA!",
      warning: "Al confirmar el pago de su suscripción, usted acepta permitr que JWPOINT S.A DE C.V cargue en su tarjeta este pago y pagos futuros de acuerdo con nuestros términos y condiciones de uso. Después de {time} meses, su suscripción se renovará automáticamente. Puede cancelar esto en cualquier momento que desee.",
      warning_singular: "Al confirmar el pago de su suscripción, usted acepta permitr que JWPOINT S.A DE C.V cargue en su tarjeta este pago y pagos futuros de acuerdo con nuestros términos y condiciones de uso. Después de {time} mes, su suscripción se renovará automáticamente. Puede cancelar esto en cualquier momento que desee.",
      warning_singular_day: "Al confirmar el pago de su suscripción, usted acepta permitr que JWPOINT S.A DE C.V cargue en su tarjeta este pago y pagos futuros de acuerdo con nuestros términos y condiciones de uso. Después de {time} días, su suscripción se renovará automáticamente. Puede cancelar esto en cualquier momento que desee.",
      title_one: "¡Aquí es donde se pone aún  más emocionante!",
      title_two: "Mejora tu cuenta y comienza a hablar con tu pareja ideal.",
      advantage: "Ventajas y accesos que obtendrás",
      video_call_title: "Videollamadas y llamadas de voz",
      video_call_content:
        "Ya no tendrás que compartir tu teléfono móvil  para realizar  llamadas o videollamadas a otros usuarios dentro de JWperfectmatch. Tendrás la  privacidad y seguridad que deseabas.",
      messages_title: "Mensajes ilimitados y Emojis",
      messages_content:
        "Podrás enviar y recibir mensajes ilimitados y Emojis  para expresarte. ¡Será emocionante!",
      couples_title: "Más parejas afines",
      couples_content:
        "Podrás contactar hasta 1000 parejas afines a tu criterio de búsqueda. ¡Suscríbete ahora!",
      photos_title: "Acceso a fotografías",
      photos_content:
        "Podrás tener acceso a todas las fotos de usuarios y fotos privadas de quien te haya invitado a verlas.",
      visits_title: "Visitas a tu perfil",
      visits_content:
        "Podrás ver quién ha visitado tu perfil y ha demostrado interés en conocerte. ¡Suscríbete!",
      security_title: "Seguridad",
      security_content:
        "JWperfectmatch es un sitio web  para Testigos de Jehová solteros como tú. Podrás hacer llamadas ilimitadas sin tener que compartir tu número de teléfono móvil. ¡Suscríbete ahora!",
      choose: "Escoge la suscripción que mejor funcione para tí",
      discount:
        "Agregue una suscripcion Premium por US $14.00 por mes. Con una suscripción premium, todas las personas a las que envíe mensajes pueden responder GRATIS y esto aumentara tus posibilidades de encontrar una pareja. (Recomendado)",
      support_message: "¡Estás en buenas manos! Nuestro equipo de soporte está conformado por hermanas y hermanos, Testigos de Jehová, trabajando por tu seguridad y privacidad.",
      upgrade: "Suscribete y actualiza tu cuenta",
      subscription: "Suscripción",
      coupon_individual: "Suscripción de {frecuency} mes + {free} mes gratis! ",
      coupon_multiple: "Compra tu suscripción de {frecuency} meses y recibe los primeros {free} meses gratis!",
      free_trial: "gratis!",
      single_charge: "Cargo único",
      charge: "cargo",
      premium_charge: "Cargo premium",
      coupon_discount: "Descuento cupón",
      will_pay: "Cargo de hoy",
      billedInOne: 'Facturado en un pago',
      subscription: "suscripción",
      cancel_subscription: "Cancelar renovación automática",
      update_payment_method: "Actualizar método de pago",
      banner_title: "¡Ahora disfrutarás de todas las ventajas!",
      banner_description:
        "¡Obten acceso a todas las funciones y ventajas que te ofrecemos! Así podrás enviar mensajes, video llamadas iimitadas y muchos más.",
      do_secure_payment: "Pago seguro",
      do_secure_payment_or: "O",
      invalid: {
        title: "Cupon invalido",
        description: "Estas tratando de comprar una promocion con un cupon invalido",
        button: "Ir a suscripciones"
      },
      alert: {
        title: "¡Atención!",
        message: "¡No limites tus posibilidades! Al deshabilitar esta opción, no podrá contactar, ni  obtener respuestas de otros usuarios no suscritos. ¿Quieres continuar?",
        yes: "Si",
        no: "No"
      }
    },
    terms_chat: {
      title: "Aviso Importante",
      description_one:
        "En Jwperfectmatch queremos protegerlo en su experiencia de citas en línea en nuestro sitio web y necesitamos su ayuda para hacerlo. Por favor, lea y acepte este importante mensaje antes de comenzar.",
      description_two:
        "Prometo nunca enviar dinero, pedir dinero a otros o compartir información financiera con cualquier persona o usuario que conozca en JWperfectmatch. Además, me comprometo a reportar a JWperfectmatch, a cualquier persona que me pida dinero o mi información financiera y también a cualquier persona que muestre una conducta y moral distinta a la que se espera para un Testigo de Jehová.",
      tips: "Obtener más consejos de seguridad"
    },
    tell_friends: {
      title: "Invita a tus amigos",
      dialog_title: "Díselo a tus amigos",
      description:
        "... O simplemente rellena este formulario y le enviaremos una invitación",
      dialog_description:
        "Gracias, tu invitación ha sido enviada correctamente. Si lo deseas puedes compartirlo con otro amigo(a).",
      email: "Correo Electrónico de tu amigo/a",
      subject: "Asunto",
      extra_message: "Mensaje",
      placeholder_subject: "Un sitio web que deberías conocer",
      placeholder_message: "Hola (nombre de tu amigo/a)",
      placeholder_extra_message: "Escribe tu mensaje",
      upload_photos: "Subir Fotografías",
      fiends_email: "O simplemente rellena este formulario y le enviaremos una invitación:",
      share: {
        title: "El amor nunca falla ... ¡Compartámoslo!",
        intro: "A los Testigos de Jehová realmente nos gusta dar buenas noticias a otros ¿no es asi?  JWperfectmatch ha sido creado para  Testigos de Jehová genuinos como tú. Nuestro equipo de apoyo está formado por hermanos y hermanas que trabajan arduamente para mantener la limpieza dentro de este sitio web.",
        title2: "¡Compartir es demostrar interés!",
        intro2: "Comparta sus buenas experiencias de JWperfectmatch con otros Testigos de Jehová solteros y genuinos",
        twitter_message: "Unete a JWperfectmatch, el sitio de citas para Testigos de Jehova Genuinos. Manejado por Testigos de Jehova.",
        facebook: "Facebook",
        twitter: "Twitter",
        email: "Email"
      }
    },
    search: {
      title: "Búsqueda",
      description: {
        unsubscribed: "Hemos encontrado más de 100 personas que cumplen con tus criterios de compatibilidad.",
        subscribed: "Hemos encontrado más de 1000 personas que cumplen con tus criterios de compatibilidad."
      },
      i_am: "Soy un/una",
      interested: "Interesado en",
      range: "Rango de edad",
      live_ideal_couple: "Donde vive tu pareja ideal",
      order: "Ordenarlos por",
      start_search: "Iniciar Búsqueda",
      labelusername:"Nombre de Usuario",
      result: "Resultado de búsqueda"
    },
    months: {
      0: "Enero",
      1: "Febrero",
      2: "Marzo",
      3: "Abril",
      4: "Mayo",
      5: "Junio",
      6: "Julio",
      7: "Agosto",
      8: "Septiembre",
      9: "Octubre",
      10: "Noviembre",
      11: "Diciembre"
    },
    profile_tabs: {
      profile:
        'Tu perfil está <span class="text-jblue-secondary font-bold">{percentage}%</span> completo',
      complete_profile: "Completar perfil",
      steps: {
        personal_information: "Información Personal",
        about_you: "Acerca de ti",
        education: "Educación",
        my_ideal_couple: "Mi pareja ideal",
        more_about_her: "Más sobre ella",
        more_about_him: "Más sobre el",
        more_about_me: "Más acerca de mi",
        your_picture: "Tu fotografía"
      },
      save: "Guardar",
      go_back: "Regresar"
    },
    steps: {
      personal_information: "Información Personal",
      about_you: "Acerca de ti",
      spiritual_qualities: "Cualidades Espirituales",
      ideal_partner: "Mi Pareja Ideal",
      pictures: "Tu Fotografía",
      confirm_tj: "Confirma que eres TJ"
    },
    step_one: {
      name: "Nombre",
      last_name: "Apellido",
      email: "Correo Electrónico",
      username: "Usuario",
      password: "Contraseña",
      confirm_password: "Confirmar Contraseña",
      profile_message: "Mensaje de perfil",
      birthdate: "Fecha de Nacimiento",
      year: "Año",
      month: "Mes",
      day: "Día",
      phone: "Teléfono Móvil",
      country: "País",
      city: "Ciudad",
      postal_code: "Código Postal",
      verify_phone: "Confirma tu teléfono móvil y se aún más confiable.",
      terms:
        'Confirmo y doy fe que tengo más de 18 años de edad y que  soy un Testigo de Jehová activo y bautizado. He leído completamente y estoy de acuerdo con los <span class="text-pink-500 font-semibold">Términos y condiciones de Uso, la Política de privacidad, las respuestas a preguntas frecuentes, soporte y los consejos de seguridad</span>. Doy mi consentimiento para el tratamiento y manejo de mis datos personales y el uso de cookies tal como está definido en la <span class="text-pink-500 font-semibold">Política de Privacidad.</span>',
      terms_and_conditions: "Terminos y condiciones",
      indication_username: "Debe ser diferente de tu nombre. Incluye solo letras y números, sin espacios, Más de 4 caracteres.",
      indication_name:"Utilice su nombre completo y correcto para evitar que su perfil sea eliminado.",
      indication_password:
        "Más de 8 caracteres, incluir números o simbolos, incluir mayúsculas",
      indication_description:
        "máximo 10 palabras, solo se permiten textos, no se permiten signos alfanumericos ni números"
    },
    step_two: {
      title:
        "Completar tu perfil es muy importante. Es la forma en que tus posibles parejas recomendadas te conocerán mejor. Tómate tu tiempo y déjale saber a tus parejas afines quién eres tú.",
      description:
        "Evita elegir la opción “otro” con demasiada frecuencia."
    },
    step_four: {
      title:
        "Subir tus fotografías te permitirá tener muchas más visitas en tu perfil...¡Muestra tu mejor sonrisa!",
      description:
        "Está demostrado que es 10 veces más probable que te contacten si tienes una o más fotos en tu perfil, independientemente de tu apariencia.",
      instructions: "Instrucciones",
      instruction_1:
        "Debes subir al menos 1 foto reciente de tí. Puedes subir hasta 10 fotos cuando te suscribas.",
      instruction_2:
        "Tu foto principal debe ser un retrato de tí solamente, sin mensajes escritos. Debe ser una foto clara y reciente de tu rostro y hombros. No puedes subir la misma foto repetidas veces. Fotos de poca calidad o resolución no serán aceptadas.",
      instruction_3: "Deshazte de las gafas de sol. No aceptamos fotografías con máscaras.",
      instruction_4:
        "Haz una mezcla de tomas individuales, sociales y de acción.",
      instruction_5:
        "Asegúrate de agregar 4 o más fotos para aumentar tu potencial de matchmaking.",
      instruction_6: "Tus fotos deben ser al menos 600x600px.",
      instruction_7: "Puedes subir tus fotos  en formato JPG, JPEG, PNG.",
      instruction_8:
        "Tus fotos deben ser al menos 600x600 px. El tamaño máximo es de 12 MB por foto.Y el máximo de almacenamiento disponible es de 120 MB",
      instruction_9:
        "Ninguna de tus fotos deberá ser provocativa, ofensiva o protegida por derechos de autor.",
      instruction_10:
        "Las imágenes son revisadas por nuestro equipo de soporte y usualmente estarán disponibles en un plazo no mayor a 72 horas.",
      instruction_11:
        "Si intentas subir fotos que no estén de acuerdo con nuestros Términos y  condiciones de uso, se te podrá bloquear o eliminar tu cuenta de usuario.",
      instruction_12:
        "Unicamente debes aparecer tu. No puedes inlcuir a nadie mas en tus fotografias.",

      profile_photo: "Foto de Perfil",
      photo_approval_pending: "Fotografias pendientes de aprobación",
      options: {
        option_1: "Deseo hacer de ésta mi foto principal.",
        option_2: "Deseo hacer visible para todos.",
        option_3: "Deseo hacer visible sólo para mis favoritos.",
        option_4: "Deseo hacer la invisible para todos los usuarios.",
        option_5: "Deseo eliminar esta foto."
      }
    },
    step_five: {
      title: "¡Ayúdanos a encontrar a tus parejas más compatibles!",
      description: "No dejes espacios en blanco. Describe a tu pareja ideal con el mayor detalle posible para tener buenos resultados en tu búsqueda.",
      ideal_couple_legend: "Tu pareja ideal respondería de esta manera si le preguntaras sobre:"
    },
    step_six: {
      title: "Confirma que eres un(a) Testigo de Jehová.",
      description:
        "¡Ahora puedes exhalar! Has llegado al último paso de tu registro en JWperfectmatch",
      another_opportunity_title:
        "¡Oops! al parecer has respondido de forma incorrecta a una o más preguntas, pero no te preocupes, tendrás otra oportunidad.",
      another_opportunity_description:
        "Por favor responde las siguientes dos preguntas de forma correcta",
      images: {
        file_upload_error:
          "Error al subir la foto."
      }
    },
    register_carousel: {
      one:
        "¡Esa maravillosa sensación... el amor romántico basado en principios!",
      two:
        'En medio de este mundo superficial… ¡La belleza más importante, la interior! <br><tooltip message="Pero Jehová dijo a Samuel: “No mires su apariencia ni lo alto de su estatura, porque lo he rechazado. Porque no de la manera como el hombre ve es como Dios ve, porque el simple hombre ve lo que aparece a los ojos; pero en cuanto a Jehová, él ve lo que es el corazón">(1 Samuel 16:7)</tooltip>',
      three:
        '¡Los Testigos de Jehová somos personas muy felices! <br><tooltip message="Felices son los que tienen conciencia de su necesidad espiritual, puesto que a ellos, pertenece el reino de los cielos.">(Mateo 5:3)</tooltip>',
      four:
        "Está demostrado, es 10 veces más probable que te contacten si tienes fotos en tu perfil.",
      five:
        'Fíjate en las cualidades espirituales, en “la persona secreta del corazón” <br><tooltip message="sino que sea la persona secreta del corazón, en la (vestidura) incorruptible  del espíritu quieto y apacible, que es de gran valor, a los ojos de Dios.">(1 Pedro 3:4;</tooltip> <tooltip message="a fin de que les conceda, según las riquezas de su gloria, que sean hechos poderosos, en el hombre que son en el interior,  con poder mediante el espíritu de él."> Efesios 3:16)</tooltip>',
      six:
        'NO HAY mayor privilegio en la Tierra que el de ser Testigo a favor del Dios verdadero, Jehová. <br><tooltip message="“Yo mismo he anunciado y he salvado y he hecho que sea oído, cuando no había entre ustedes dios extraño. De modo que ustedes son mis testigos”, es la expresión de Jehová, “y yo soy Dios.”">(Isaías 43:12)</tooltip>'
    },
    contact: {
      title: "Contáctanos",
      disclaimer:
        'Antes de enviarnos cualquier pregunta que pueda tener, asegúrese de haber leído los <router-link class="text-pink-500 no-underline" to="/support">\'Términos de uso y las Preguntas frecuentes\'</router-link> En esas secciones, encontrará las respuestas a la mayoría de las preguntas que recibimos de nuestros usuarios.',
      suggestion: "Si deseas darnos tus sugerencias, serán bienvenidas.",
      have_you_read: "¿Has leído los Términos de Uso y las preguntas frecuentes?",
      choose: "Elegir una respuesta",
      answer_one: "Si, si he leído los Términos de Uso y las preguntas frecuentes",
      answer_two: "No, no he leido los Términos de Uso y las preguntas frecuentes",
      subject: "Asunto",
      email: "Correo Electrónico",
      message: "Tu mensaje",
      message_placeholder: "Escribe tu mensaje un máximo de 500 palabras",
      continue: "Continuar",
      dialog_title: 'Enviado con exito',
      success: "Nos comunicaremos lo mas pronto posible.",
      mailto: "Envíanos un mensaje a:"
    },
    chat: {
      default_answer: "Selecciona una respuesta predeterminada",
      blocked: "¡Bloqueado!",
      blocked_message: "Este usuario te ha bloqueado.",
      audio: "Tuviste una llamada con ",
      video: "Tuviste una videollamada con ",
      ongoing: "Llamada en curso..."
    },
    coupons: {
      get_coupon: "Obtener cupón",
      coupon1: {
        title: "1 mes gratis",
        description:
          "¡Estás a solo un “click” de conocer a tu pareja ideal! Haz click en el siguiente botón AHORA y podrás realizar llamadas, videollamadas y mensajes de texto gratis durante el primer mes."
      },
      coupon2: {
        title: "2 meses gratis",
        description:
          "Obtén los primeros dos meses gratis al comprar tu suscripción de tres meses. Haz click en el siguiente enlace  y podrás disfrutar de todos los servicios: realizar llamadas, videollamadas y mensajes gratis durante los dos primeros meses."
      },
      coupon3: {
        title: "50% de descuento",
        description:
          "Obtén el 50% de descuento en todas las suscripciones de 6 o 12 meses. Haz click en el siguiente enlace  y podrás disfrutar de todos los servicios: realizar llamadas, videollamadas y mensajes gratis durante la primera mitad de tu periodo de suscripción"
      },
      title: "Cupones Promocionales",
      description:
        "Felicidades, has recibido los siguientes cupones promocionales por tiempo limitado.  Dale una actualización a tu cuenta y ¡comienza a disfrutar de todos nuestros beneficios!"
    },
    success_dialog: {
      title: "¡Registro exitoso!",
      description:
        "Tu registro se ha realizado con éxito",
    },
    strike_dialog: {
      title: "Información de registro",
      description:
        "Oops! Lo sentimos mucho, tus respuestas no han sido correctas. Podrás volverlo a intentar en 24 horas nuevamente",
      description:
        "Oops! Lo sentimos mucho, tus respuestas no han sido correctas. Podrás volverlo a intentar nuevamente",
      accept: "Aceptar"
    },
    banned_dialog: {
      title: "Información de registro",
      description:
        "Lo sentimos, tus respuestas no han sido las correctas. Si lo deseas puedes comunicarte con nosotros al correo hello@jwperfectmatch.com y exponer tu caso para evaluación.",
      accept: "Aceptar"
    },
    home: {
      heading: 'JWperfectmatch es el sitio de citas para Testigos de Jehová Genuinos.',
      one:
        '¿Estás soltero(a) porque quieres obedecer el mandato de casarte "Solo en el Señor"?',
      two:
        `Puedes estar seguro(a) de que Jehová Dios está contento con tu decisión. <br><tooltip :customClasses="['text-jpink-primary']" message="A su vez Samuel dijo: “¿Se deleita tanto Jehová en ofrendas quemadas y sacrificios como en que se obedezca la voz de Jehová? ¡Mira! El obedecer es mejor que un sacrificio, el prestar atención que la grasa de carneros;">(1 Samuel 15:22;</tooltip> <tooltip :customClasses="['text-jpink-primary']" message="Sé sabio, hijo mío, y alegra mi corazón para que yo le pueda responder al que me desafía.">Proverbios. 27:11)</tooltip>`,
      three:
        `Jehová ha instruido que la congregación debe estar limpia de contaminación. <tooltip :customClasses="['text-jpink-primary']" message="Apártense, apártense, sálganse de allí, no toquen nada inmundo; sálganse de en medio de ella, manténganse limpios, ustedes, los que llevan los utensilios de Jehová.">(Isaías 52:11)</tooltip>`,
      four:
        `Los Testigos de Jehová no consideran que el contacto romántico ó salir con alguien más sea un pasatiempo, sino un paso serio hacia el matrimonio, el cual debe honrar a nuestro Dios Jehová. <tooltip :customClasses="['text-jpink-primary']" message="No lleguen a estar unidos bajo yugo desigual con los incrédulos. Porque, ¿qué consorcio tienen la justicia y el desafuero?, ¿O qué participación tiene la luz con la oscuridad?">(2. Cor. 6:14)</tooltip>`,
      five:
        "Nuestro objetivo en JWperfectmatch es reunir a miembros activos de la congregación mundial de los Testigos de Jehová, interesados en buscar amistad o construir una relación amorosa auténtica, en un ambiente lo más seguro y limpio posible, sin contaminación.",
      six:
        "JWperfectmatch es un sitio diseñado exclusivamente para Testigos de Jehová solteros(as), que te ayudará a encontrar a alguien que llene tus expectativas y que comparta tus mismos valores, principios, amor y obediencia por Jehová Dios."
    },
    edit_profile: {
      title: "Configuración general",
      personal_information: "Información general",
      form: {
        first_name: "Nombre",
        last_name: "Apellido",
        full_name: "Nombre completo",
        email: "Correo Electrónico",
        username: "Usuario",
        password: "Contraseña",
        country: "País",
        phone: "Teléfono",
        zip_code: "ZIP/Código Postal",
        make_visible:
          "¿Hacer mi perfil visible para el resto de usuarios?",
        visible: "Visible",
        invisible: "Invisible",
        preferred_language: "Mi idioma preferido para este sitio web"
      },
      couples: {
        title: "Configuración parejas afines",
        show_users:
          "Mostrarme sólo usuarios que han visitado el sitio en los últimos",
        is_important_photo:
          "¿Considero importante que la otra persona tenga foto(s) en su perfil?",
        accept_messages:
          '¿Aceptarías mensajes de otros usuarios aunque no cumpla con alguno de tus requisitos "no negociables"?'
      },
      notifications: {
        title: "¿Desea recibir notificaciones por email acerca de?",
        activity: "Actividad de mi perfil",
        news: "Ultimas noticias, novedades y nuevas funciones",
        frequency: "Frecuencia de las notificaciones de nueva pareja a fin",
        discounts: "Descuentos y ofertas promocionales",
        notify: "Notificarme un nuevo mensaje",
        guidance: "Consejos, recomendaciones, etc"
      },
      delete_profile: "Solicitar borrar mi perfil",
      download_information: "Descargar mi información personal",
      save_changes: "Guardar Cambios"
    },
    gifts: {
      title: "¡Excelente decisión!",
      description:
        "Al enviarle un regalo de suscripción a {name}, le expresas con hechos que te interesa. {gender} unicamente podrá usar una suscripción de regalo temporal por siete dias, para comunicarse contigo.",
      message:
        "Agrega una suscripción Premium por $14.00, asi podrás obtener respuesta de TODAS LAS PERSONAS a las que envíes mensajes.",
      single_charge: "Cargo único",
      subscription: "Suscripción de 7 días",
      gender: {
        male: "El",
        female: "Ella"
      }
    },
    payment_messages: {
      success: {
        title: "Su pago fue exitoso!",
        body: "El pago de tu suscripción fue realizado con éxito."
      },
      error: {
        title: "¡Error!",
        body: "Hubo un error al procesar tu pago, intenta de nuevo."
      },
      back_to_app: "Continuar"
    },
    photos: {
      first_message: "Sube tus fotografías",
      first_message_more: "Clic aquí para subir más",
      second_message: 'Click en "Guardar" al concluir',
      my_photos: "Mis Fotografías",
      upload_photos: "Subir Fotografías"
    },
    has_photo_options: {
      nothing_important: "Nada importante",
      is_important: "Si, me importa"
    },
    match_profile: {
      about_her: "Sobre su personalidad",
      about_his: "Sobre su personalidad",
      about_her_ideal_match: "Personalidad de su pareja ideal",
      about_his_ideal_match: "Personalidad de su pareja ideal"
    },
    registration: {
      bad_news: "¡Malas noticias!",
      oops: "¡Oops!",
      continue_process:
        "Por favor confirma que eres un Testigo de Jehová, respondiendo a las siguientes preguntas:",
      failed_attemps:
        "Lastimosamente no sé puede continuar el proceso de registro ya que se han tenido menos aciertos de los esperados, muchas gracias por intentarlo.",
      wait_24:
        "Para poder realizar de nuevo el test para comprobar que eres TJ por favor espera 24 Horas para el nuevo intento.",
      used_link:
        "Este enlace ya fue utilizado con anterioridad, por lo tanto ya no se puede modificar la recuperación del examen"
    },
    profile: {
      about_her: "Sobre Ella",
      about_him: "Sobre El",
      about_his_match: "Sobre su Pareja Ideal",
      about_her_match: "Sobre su Pareja Ideal",
      not_found: "Perfil no encontrado",
      profile_not_found: "El perfil que buscas no existe.",
      close: "Cerrar",
      spititual_goals: "Sus Metas Espirituales",
      photos: {
        max_file_exceeded: {
          title: "Se excedió el número de fotos permitidas",
          description: "Elimine algunas imágenes e intente nuevamente",
          accept: "Accept"
        },
        validation_error: "Debes subir almenos una fotografia tuya que cumpla con los lineamientos.",
        upload_error: "Error al cargar imágenes, elimínelas o vuelva a intentarlo."
      }
    },
    gender: {
      her: "ella",
      him: "el"
    },
    delete_photo: {
      title: 'Eliminar fotografía',
      description: '¿Seguro que quieres eliminar tu foto?',
      accept: 'Si, estoy seguro',
      cancel: 'Cancelar',
      onLessQuantity: {
        description: 'Si notas que todas las imágenes están borrosas es porque solo puedes ver tus parejas afines y sus perfiles si además tienes al menos una foto. Todas las fotos estarán borrosas a menos que tu también tengas al menos una.',
        accept: 'Aceptar',
        cancel: 'Subir Foto',
      }
    }
  },
  delete_user:{
    valueMemberModal: '¡Eres un miembro valioso de la familia JWperfectmatch y no queremos que te vayas!',
    didYouKnowModal: 'Para su comodidad, su perfil tiene una opción muy útil "invisible", que hace que su perfil sea invisible para todos los demás usuarios. Puede utilizar esta opción en cualquier momento, sin necesidad de cerrar su cuenta. Puede cambiar fácilmente esta configuración haciendo clic en "editar perfil" en la esquina superior derecha de la página de su perfil.',
    dontLeaveUsModal: '¡No queremos verte partir!',
    noKeepModal: 'Conservar mi perfil',
    yesDeleteModal: 'Eliminar mi perfil',
    fillTheFieldsModal: 'Por favor, complete los campos',
    reasonsModal: 'Razones por las que desea eliminar su cuenta',
    requestDeleteModal: 'Solicitar eliminación',
    completeTheFieldsModal: 'Por favor complete todos los campos',
    requestCompleted: 'Tu solicitud ha sido enviada',
  },
  muted: {
    title : "Perfil bajo revisión",
    message: "Por favor Intentalo de nuevo mas tarde"
  },
  message_limit: {
    message:"Oops, parece que has superado el límite diario de mensajes. Al suscribirte, puedes enviar mensajes de texto gratis y un número ilimitado de chats a cualquier usuario.<br> ¡Suscríbete hoy!"
  },
  edit_profile_limit: {
    message: "¡Suscríbete para mejorar tu perfil!"
  },
  picture_limit: {
    message: "Suscríbete y haz que  tu perfil atraiga aun  mas la atencion de otros usuarios subiendo hasta 10 fotos",
    cancel : "Suscribirme después",
    subscribe: "Suscribirme ahora"
  }
};
export default es;
